<!-- Profiles Section starts here -->
<div *ngIf="OTAData && isOverTheAirUpdatesEnabled!=undefined"> 
    <div *ngIf="isOverTheAirUpdatesEnabled && !viewDevicesClicked" id="profileTabDiv" class="content__wrapper">
        <!-- Navtabs -->
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" (click)="setIndex(0)" [ngClass]="{'active': tabIndex === 0}">
                    <span>{{globConst.PROFILES_TAB_TEXT}}</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" (click)="setIndex(1)" [ngClass]="{'active': tabIndex === 1}">
                    <span>{{globConst.UPDATE_IPOS_TAB_TEXT}}</span></a>
            </li>
        </ul>
        <div class="tab-content" id="tabContent">
            <div id="tabIndex0" *ngIf="tabIndex === 0" class="tab-pane p-0" [ngClass]="{'active': tabIndex === 0}">
                <iposcen-profile [tabIndex]="0"></iposcen-profile>   
            </div>
            <div id="tabIndex1" *ngIf="tabIndex === 1" class="tab-pane" [ngClass]="{'active': tabIndex === 1}">
                <iposcen-profile [tabIndex]="1"></iposcen-profile>   
            </div>
        </div>
    </div> 
    <div class="content__wrapper tab-content" id="tabContent" *ngIf="viewDevicesClicked">
        <div class="topHeader">
            <div class="blueHighlighter" (click)="navToMainStream()">
                <span class="hide-filters-icon"></span>
                <span>{{packageData.standardType ? (isIposLite ? globConst.IPOS_LITE_PRC : globConst.MAINSTREAM_TEXT) : packageData.profileName}}</span>
            </div>
            <div>
                <strong> {{globConst.LATEST_IPOS_VERSION}} </strong>{{iposLegalVersion}}
            </div>
        </div>
        <div class="tab-pane active mainstream">
            <iposcen-device-dashboard [pkgdata]="packageData"></iposcen-device-dashboard>
        </div>
    </div> 
    
    <div *ngIf="!isOverTheAirUpdatesEnabled && !viewDevicesClicked" id="existingProfileDiv">
        <iposcen-profile [tabIndex]="0"></iposcen-profile>   
    </div> 
</div>
